// extracted by mini-css-extract-plugin
export default {"faqColumn":"FaqCol_faqColumn__mvBOq","active":"FaqCol_active__qEmfB"};